import React from 'react';

const ExpandCollapseButton = ({ 
  itemKey, 
  sectionType, 
  doc2Visibility, 
  toggleDoc2Visibility,
  style = {}
}) => {
  const sectionKey = itemKey + "_" + sectionType;
  
  return (
    <section
      style={{
        position: 'relative',
        fontStyle: 'italic',
        fontSize: '13px',
        color: '#526666',
        padding: '2px 0px',
        display: 'inline',
        margin: '2px',
        float: 'right',
        cursor: 'pointer',
        zIndex: '999',
        ...style
      }}
      onClick={() => toggleDoc2Visibility(sectionKey)}
    >
      {doc2Visibility[sectionKey] ? 'Expand Section' : 'Collapse Section'}
      <span
        style={{
          marginLeft: '8px',
          display: 'inline-block',
          width: '0',
          height: '0',
          borderTop: '4px solid transparent',
          borderBottom: '4px solid transparent',
          borderLeft: '8px solid #526666',
          transform: doc2Visibility[sectionKey] ? 'rotate(0deg)' : 'rotate(90deg)',
          transformOrigin: '4px 50%',
          transition: 'transform 0.2s ease',
        }}
      ></span>
    </section>
  );
};

export default ExpandCollapseButton;
